import { tokenRequestSearch } from '@server/insurance-policy/insurance-policy.dto';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/signup/org/$id')({
  validateSearch: tokenRequestSearch,
  loaderDeps: ({ search: { token } }) => ({ token }),
});
